import { Component } from '@angular/core';
import { LocationService } from 'src/app/services/locations/location.service';
import { BranchService } from 'src/app/services/branches/branch.service';
import { ApiResponse } from 'src/app/models/IApiResponse';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { StockService } from 'src/app/services/stock/stock.service';

@Component({
  selector: 'app-export-stock',
  templateUrl: './export-stock.component.html',
  styleUrls: ['./export-stock.component.css']
})
export class ExportStockComponent {
  form!: FormGroup;
  public isInProgress: boolean = false;
  submitted: boolean = false;
  isProcessing: boolean = false;
  public errorMessage: string | null = null;
  public warningMessage: string | null = null;
  public successMessage: string | null = null;
  locations: any[] = [];
  branches: any[] = [];
  showBranchDropdown: boolean = false;

  constructor(
      private locationService:LocationService,
      private branchService:BranchService,
      private stockService:StockService,
      private formBuilder: FormBuilder,
    ){
      this.form = this.formBuilder.group({
        location: ['', Validators.required],
        branch: [''],
      })
  }

  ngOnInit(): void {
    this.isInProgress=true;
    this.fetchLocations();
  }

  fetchLocations():void{
    this.locationService.getAllLocations().subscribe((response: ApiResponse) =>this.locations = response.data);
  }
    
  /**
   * Load branches when the location is selected
   */
  onLocationChange(target: EventTarget|null) {
    if (target instanceof HTMLSelectElement) {

      const location = target.value;
      
      if(location!=='' && location!==undefined){
        this.showBranchDropdown = !["all", "enroute", "on_port"].includes(location);

        if(this.showBranchDropdown){
          this.isInProgress=true;
          this.fetchBranchesByLocation(location);
        }else{
          this.branches = []; // Clear the branches
        }
      }else{
        this.branches = []; // Clear the branches
      }
    }
  }

  fetchBranchesByLocation(locationId: string):void {
    this.branchService.getBranchesByLocation(locationId)
    .subscribe({
      next: (response) => {
        if(response.status==='success'){
          this.branches = response.data
          this.isInProgress=false;
          this.errorMessage=null;
        }else if(response.status==='no_data'){
          this.errorMessage="No branches found within the selected location!";
          this.isInProgress=false;
          this.branches = []; // Clear the branches
        }else{
          this.errorMessage="Unable to load branches within the selected location. Please try again or consult your system administrator!";
          this.isInProgress=false;
          this.branches = []; // Clear the branches
        }
      },
      error: (error) => {
        this.errorMessage=error;
        this.isInProgress=false;
        this.branches = []; // Clear the branches
      }
    });
  }

  handleSubmit(){
    this.submitted = true;
    this.successMessage=null
    this.errorMessage=null;

    if (this.form.valid) {
      if(this.showBranchDropdown && this.form.value.branch==''){
        this.errorMessage="Please select branch to proceed!";
        this.successMessage=null
      }else{
        this.isProcessing = true;
        this.stockService.exportStock(this.form.value.location,this.form.value.branch)
      .subscribe({
        next: (response: Blob) => {
          this.submitted = false;
            this.isProcessing = false;
            // Create a download link for the file
            const blob = new Blob([response], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = 'STOCK.xlsx'; // Set filename
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);

            this.successMessage = "Stock exported successfully!";
            this.errorMessage=null;
        },
        error: (error) => {
          this.submitted = false;
          this.isProcessing = false;
          this.errorMessage="Export failed. Please try again!";
          this.successMessage=null
          console.error("Download error:", error);
        }
      });
      }
    }
  }
}
